import { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  readonly layout?: 'stack' | 'grid';
  readonly columns?: number;
  readonly children: ReactNode;
}

/** Arranges generative-UI children as a vertical stack or a CSS grid. */
export function LayoutContainer({
  layout = 'stack',
  columns = 2,
  children,
}: Props): JSX.Element {
  if (layout === 'grid') {
    const cols = Math.min(Math.max(Math.trunc(columns) || 2, 1), 4);
    return <Grid $columns={cols}>{children}</Grid>;
  }
  return <Stack>{children}</Stack>;
}

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Grid = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, minmax(0, 1fr));
  gap: 8px;
`;
